module.exports = __webpack_public_path__ + "static/media/img7.e96fa1a6.webp";